import { render, staticRenderFns } from "./DemandeReinscriptionTableau.vue?vue&type=template&id=ec28a954"
import script from "./DemandeReinscriptionTableau.vue?vue&type=script&lang=js"
export * from "./DemandeReinscriptionTableau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports